/**
 * A qué tamaño se escribe una opción según lo que ocupe.
 *
 * El recuadro no cambia: son cuatro celdas iguales y así se quedan, porque una cuadrícula que
 * baila según lo que se haya escrito obliga a buscar el botón cada vez. Lo que se adapta es la
 * letra, que es lo que puede hacerlo sin mover nada de sitio.
 *
 * Los tramos van por número de caracteres y no midiendo la caja: medir exige leer la maquetación
 * después de pintar y volver a pintar, y eso en el móvil del alumno se ve. El límite del dominio
 * son 160 caracteres, así que el tramo más pequeño es el del texto más largo que se admite.
 */
export function tamanoSegunTexto(texto: string, base = '--text-option'): string {
  const largo = texto.length;
  if (largo <= 32) return `var(${base})`;
  if (largo <= 70) return `calc(var(${base}) * 0.86)`;
  if (largo <= 110) return `calc(var(${base}) * 0.74)`;
  return `calc(var(${base}) * 0.64)`;
}
